import Header from "../../components/molecules/header/Header";
import Footer from "../../components/molecules/footer/Footer";
import { useState } from "react";
import "./admin.scss"
import Administradores from "../../components/organisms/administradores/Administradores";
import Estadisticas from "../../components/organisms/estadisticas/Estadisticas";
import UsuariosWeb from "../../components/organisms/usuariosweb/UsuariosWeb";
import Nominas from "../../components/organisms/nominas/Nominas";
import Certificados from "../../components/organisms/certficados/Certificados";
import CertificadosRet from "../../components/organisms/certficados/CertificadosRet";
import Configuracion from "../../components/organisms/configuracion/Configuracion";
import { useNavigate } from "react-router-dom";


const Adminitracion = () => {
    const navigate = useNavigate();
    const [zona, setZona] = useState({
        administradores: true,
        estadisticas: false,
        usuWeb: false,
        nominas: false,
        cert: false,
        certRet: false,
        config: false
    })

    const botonOpcion = (titulo, name) => {
        return <button
            className={`btn2 rounded my-2 me-2 p-1 ${zona?.[name] ? "btn2Active" : null}`}
            type="button"
            onClick={() => { setZona({ [name]: true }) }}
        >
            {titulo}
        </button>;
    }

    return (<>
        <Header />
        <div className="container-fluid container-admin my-4 d-flex gap-2" role="main" data-landmark-index="4">
            <div className="acciones bg1 rounded scroll-list col-12 col-md-4 py-3">
                <div className="col-10"> {botonOpcion("Administradores", "administradores")}</div>


                {/* {botonOpcion("Estadísticas", "estadisticas")} */}
                <div className="col-10">{botonOpcion("Usuarios Web", "usuWeb")}</div>
                <div className="col-10"> {botonOpcion("Nóminas", "nominas")}</div>
                <div className="col-10"> {botonOpcion("Estadísticas", "estadisticas")}</div>
                <div className="col-10"> {botonOpcion("Cert. Retenciones", "certRet")}</div>
                <div className="col-10">{botonOpcion("Certificados de concursos laborales", "cert")}</div>
                <div className="col-10">{botonOpcion("Configuración", "config")}</div>
                {/* {botonOpcion("Certificados de concursos laborales", "cert")} */}
            </div>
            <div className="zonas bg1 rounded col-12 col-md-8">
                {zona.administradores ? (<><Administradores></Administradores></>) : null}
                {zona.estadisticas ? (<><Estadisticas></Estadisticas></>) : null}
                {zona.usuWeb ? (<><UsuariosWeb></UsuariosWeb></>) : null}
                {zona.nominas ? (<><Nominas></Nominas></>) : null}
                {zona.cert ? (<><Certificados></Certificados></>) : null}
                {zona.certRet ? (<><CertificadosRet></CertificadosRet></>) : null}
                {zona.config ? (<><Configuracion></Configuracion></>) : null}


            </div>
        </div>
        <div className="mb-4 ms-md-3 ms-xl-5">
            <div className="col-3">
                <button
                id="volver"
                className="btnRed rounded btnCancelarDocumentacion py-1 px-5"
                type="button"
                onClick={() => {
                    navigate(`/home`)
                }}
            >
                <i className="fa-solid fa-rotate-left"></i> Volver
            </button>
            </div>
            
        </div>

        <Footer></Footer>
    </>)
}

export default Adminitracion;


